import { Ether } from '../../types'
import { useMaintenanceMargin } from './useMaintenanceMargin'
import { useMemo } from 'react'
import { bn, w2e } from '../../utils/number'
import { Pow18 } from '../../config'
import { useRealTimeUnrealizedPnL } from './useRealTimeUnrealizedPnL'
import { useTotalSpotConversionMarginValue } from './useTotalSpotConversionMarginValue'
import { useTotalFrozenMargin } from './useTotalFrozenMargin'

export function useRiskRatio(): Ether {
  const maintenanceMargin = useMaintenanceMargin()
  const spotMargin = useTotalSpotConversionMarginValue()
  const frozenMargin = useTotalFrozenMargin()
  const unrealizedPnL = useRealTimeUnrealizedPnL()

  return useMemo(() => {
    if (bn(maintenanceMargin).isZero()) return '0'
    if (spotMargin.isZero()) return '0'

    const denominator = spotMargin.sub(frozenMargin).add(unrealizedPnL)
    if (denominator.isZero()) return '0'

    return w2e(bn(maintenanceMargin).mul(Pow18).div(denominator))
  }, [maintenanceMargin, spotMargin, frozenMargin, unrealizedPnL])
}
